<template>
    <footer class="main-footer">
        <div class="container">
            <div class="row">
                <div class="col-sm-12 col-sm-5 col-md-6">
                    <div class="row">
                        <div class="footer-about col-sm-10 col-md-8">
                            <div class="footer-logo">
                                <router-link to="/"><img src="../../assets/logo3.png"></router-link>
                            </div>
                            <p class="about-us-footer">Alquila salas de reuniones por horas al mejor precio</p>
                            <p class="copy-right font12">&#169; Copyright 2019 Vola Coworking - by <a
                                    href="https://vola.cat" target="_blank" rel="noopener noreferrer">Internet
                                Operadores</a></p>
                        </div>
                    </div>
                </div>
                <div class="col-sm-12 col-sm-7 col-md-6">
                    <div class="row gap-20">
                        <div class="col-xss-6 col-xs-4 col-sm-4 mt-30-xs">
                            <h4 class="footer-title">Compañía</h4>
                            <ul class="menu-footer">
                                <li><a href="#">Sobre Nosotros</a></li>
                                <li><a href="#">Partners</a></li>
                                <li><a href="#">Aviso Legal</a></li>
                                <li><a href="#">Términos</a></li>
                                <li><a href="#">Privacidad</a></li>
                            </ul>
                        </div>
                        <div class="col-xss-6 col-xs-4 col-sm-4 mt-30-xs">
                            <h4 class="footer-title">Descubre Vola</h4>
                            <ul class="menu-footer">
                                <li><a target="_blank" rel="noopener noreferrer"
                                       href="https://vola.cat/enterprise/service/7">Hosting</a></li>
                                <li><a target="_blank" rel="noopener noreferrer"
                                       href="https://vola.cat/enterprise/service/12">CiberSeguirdad</a></li>
                                <li><a target="_blank" rel="noopener noreferrer"
                                       href="https://vola.cat/enterprise/internet/fibra">Internet</a></li>
                                <li><a target="_blank" rel="noopener noreferrer"
                                       href="https://vola.cat/enterprise/telefono/centralita">Telefonía</a></li>
                                <li><a target="_blank" rel="noopener noreferrer"
                                       href="https://vola.cat/enterprise/service/4">Backups</a></li>
                            </ul>
                        </div>
                        <div class="col-xss-12 col-xs-4 col-sm-4 mt-30-xs">
                            <h4 class="footer-title">RRSS</h4>
                            <ul class="menu-footer for-social">
                                <li><a href="#">Facebook</a></li>
                                <li><a href="#">Twitter</a></li>
                                <li><a href="#">Linkedin</a></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </footer>
</template>
<script>
    export default {
        name: 'footerTemp'
    }
</script>
<style scoped>
    .menu-footer a:hover {
        color: #8ac6c4 !important;
    }
</style>